// @flow

const DialogStatusEnum = Object.freeze({
    Loading: 'LOADING',
    Success: 'SUCCESS',
    Initial: 'INITIAL',
    Error: 'ERROR'
});

export default DialogStatusEnum;
